import { isIncludedIn } from "./helpers";
var ExcludedIntervalHandler = /** @class */ (function () {
    function ExcludedIntervalHandler(ranges) {
        this.ranges = ranges;
        // {}
    }
    ExcludedIntervalHandler.prototype.getStatus = function (from, to) {
        for (var _i = 0, _a = this.ranges; _i < _a.length; _i++) {
            var range = _a[_i];
            if (isIncludedIn(from, to, range.from, range.to)) {
                return {
                    from: from, to: to,
                    data: {},
                    debug: range,
                    isAvailable: false,
                    reason: "Slot is excluded",
                    name: this.constructor.name
                };
            }
        }
        return {
            data: {},
            isAvailable: true,
            name: this.constructor.name
        };
    };
    return ExcludedIntervalHandler;
}());
export { ExcludedIntervalHandler };
